//== open dialog - handles opening modal dialogs and loading iframe content

document.querySelectorAll('.btn-modal').forEach((button) => {
  button.addEventListener('click', () => {
    const dialogId = button.getAttribute('data-dialog');
    const dialog = document.getElementById(dialogId);

    if (!dialog) return;

    //== Load iframe video from data-src if present
    const iframe = dialog.querySelector('iframe');
    const src = iframe?.dataset?.src;

    if (iframe && src) {
      iframe.src = src;
    }

    dialog.showModal();
  });
});

//== close dialog - handles closing dialogs and stopping video/iframe playback

const closeDialog = (dialog) => {
  if (!dialog) return;

  const video = dialog.querySelector('video');
  const iframe = dialog.querySelector('iframe');

  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  if (iframe) {
    //== reload iframe to stop video playback (resets YouTube/Vimeo etc)
    iframe.src = iframe.src;
  }

  dialog.close();
};

document.querySelectorAll('.btn-close').forEach((button) => {
  button.addEventListener('click', () => {
    const dialog = button.closest('dialog');
    closeDialog(dialog);
  });
});

//== backdrop click to close - for non-modal dialogs, close when clicking outside content

document.querySelectorAll('dialog').forEach((dialog) => {
  if (dialog.hasAttribute('data-non-modal')) {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDialog(dialog);
      }
    });
  }
});
